import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  importBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 15,
    margin: '62px 32px 0px 32px',
    padding: 10,
    minHeight: '176px',
    border: '1px  dashed #000000',
    borderRadius: '6px',
    cursor: 'pointer',
    [useBreakpoints(theme).lessThan.sm]: {
      margin: 15,
    },
    '& > p': {
      fontSize: 18,
      innerHeight: 24,
      fontWeight: 500,
      color: '#A8A8A8',
      textAlign: 'center',
    },
  },

  importBtn: {
    backgroundColor: '#183560',
    color: '#FAFDFF',
    fontWeight: 500,
    borderRadius: 4,
    padding: 8,
    cursor: 'pointer',
  },

  infoCSVFileWrapp: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    margin: '12px 32px 0px 32px',
    [useBreakpoints(theme).lessThan.sm]: {
      margin: '12px 15px 5px 15px',
    },
    '& > p': {
      fontSize: 14,
      color: '#075985',
      cursor: 'pointer',
    },
  },

  boxCSVDownloadBtn: {
    color: '#075985 !important',
    textTransform: 'none',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 'normal',
    backgroundColor: 'transparent !important',
    padding: 0,
    textDecoration: 'none !important',

    '& span': {
      display: 'flex',
      alignItems: 'center',
    },
    '& img': {
      marginRight: 4,
    },
  },
}))
